import { withDatabase } from "@nozbe/watermelondb/DatabaseProvider";
import React from "react";
import { Spacings, View } from "react-native-ui-lib";
import { compose } from "recompose";
import {
  Button,
  Page,
  ThemeContextType,
  Text,
  VStack,
  withThemeProvider,
  Stack,
} from "@towersystems/roam-common-native";
import { withAuthenticationProvider } from "@towersystems/roam-common-native/lib/utilities/authentication";
import { AntDesign } from "@expo/vector-icons";
type Props = { theme: ThemeContextType };

class DataErrorBoundaryClass extends React.Component<Props> {
  state = { hasError: false };

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {}

  resetAndLogoutFn() {
    //@ts-ignore
    const database = this.props.database;
    database
      .write(async () => {
        return database.unsafeResetDatabase().catch((err: any) => {
          console.log("FINDME: error", err);
        });
      })
      .then(() => {
        //@ts-ignore
        this.props.authentication.logout();
      });
  }

  render() {
    const { theme } = this.props;

    const actionMarkup = (
      <View style={{ marginTop: Spacings.s4 }}>
        <Stack>
          <Button
            isAction
            label="Refresh page"
            onPress={() => window.location.reload()}
          />
          <Button
            isDestructive
            label="Clear Data and Logout"
            onPress={this.resetAndLogoutFn.bind(this)}
          />
        </Stack>
      </View>
    );

    if (this.state.hasError) {
      return (
        <Page>
          <VStack
            spacing={Spacings.s2}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Text variant="heading">Whoops!...</Text>
            <AntDesign name="warning" size={50} color="#FB5F68" />
            <Text variant="heading2">Something went wrong</Text>
            <Text variant="caption">
              Refresh page to try again, or reset local data.
            </Text>
            {actionMarkup}
          </VStack>
        </Page>
      );
    }
    //@ts-ignore
    return this.props.children;
  }
}

export const DataErrorBoundary = compose(
  withAuthenticationProvider,
  withThemeProvider,
  withDatabase
  //@ts-ignore
)(DataErrorBoundaryClass) as any;
